export const SOEA_EXEMPT_JOB_CODES = [
  'AEI',
  'AO',
  'AOI',
  'CADOC',
  'CAICO',
  'CANRS',
  'CDCP',
  'CECD',
  'CECT',
  'CU CA',
  'CUCA',
  'CUCE',
  'DECKCI',
  'ELCD',
  'ENCD',
  'ENCI',
  'ENGCI',
  'OBC',
  'RADOC',
  'RAICO',
  'RANRS',
  'RCDD',
  'RCEC',
  'RCED',
  'RDCD',
  'REC',
  'RECD',
  'RECT',
  'RNCD',
  'S8400',
  'S8410',
  'SKAO',
  'SKOBC',
  'TAE',
  'TAO',
  'TOBC',
  'TOTE',
  'UKCA',
  'UKCD',
  'UKCE',
  'XDCT',
  'XECT',
  'XEOC',
  'ZAE',
  'ZAO',
  'ZELD',
  'ZEND',
  'ZOBC',
];
